import { createContext, useContext } from 'react';

/**
 * Whether approving a Watchlist change can pin the latest factor data now, as
 * the polled Watchlist context status reports it (`apply_factor_source_ready`).
 * `false` means Apply would be refused until new factor data finishes
 * publishing; `true`, `null` or no provider never block Apply.
 */
const WatchlistApplyFactorSourceContext = createContext(undefined);

export const WatchlistApplyFactorSourceProvider = WatchlistApplyFactorSourceContext.Provider;

export function useWatchlistApplyFactorSourceReady() {
    return useContext(WatchlistApplyFactorSourceContext);
}
